import React from 'react'
import { Link } from 'gatsby'

import { getFormattedDate } from '../utils/helpers'

export const Post = ({ node, prefix, newspaper, reading }) => {
  let formattedDate

  if (node.date) {
    if (!newspaper) {
      const dateArr = node.date.split(' ')
      dateArr.pop()

      dateArr[0] = dateArr[0].slice(0, 3)
      formattedDate = dateArr.join(' ').slice(0, -1)
    } else {
      formattedDate = getFormattedDate(node.date)
    }
  }

  const to = prefix ? `/${prefix}${node.slug}` : node.slug

  // Read Out Loud: the title is the piece being read, so also show who wrote it and when
  if (reading) {
    return (
      <Link to={to} key={node.id} className="post reading">
        <div className="reading-body">
          <h3>{node.title}</h3>
          {(node.author || node.published) && (
            <p className="reading-meta">
              {node.author && <span className="reading-author">{node.author}</span>}
              {node.author && node.published && (
                <span className="reading-separator" aria-hidden="true">
                  ·
                </span>
              )}
              {node.published && (
                <span className="reading-published">{node.published}</span>
              )}
            </p>
          )}
        </div>
        <time title="Dibaca pada">{formattedDate}</time>
      </Link>
    )
  }

  return (
    <Link to={to} key={node.id} className="post">
      <h3>{node.title}</h3>
      <time>{formattedDate}</time>
    </Link>
  )
}
